import { Cuenta } from "./cuenta";

export class Consorcio {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string | null,
    public readonly RazonSocial: string | null,
    public readonly NroDocumento: string | null,
    public readonly TipoDocumentoId: number | null,
    public readonly ProvinciaId: number | null,
    public readonly PaisId: number | null,
    public readonly Direccion: string | null,
    public readonly CodigoPostal: string | null,
    public readonly Telefono: string | null,
    public readonly Email: string | null,
    public readonly TipoResponsableIvaId: number | null,
    public readonly InteresVencimiento: number | null,
    public readonly InteresMensual: number | null,
    public readonly ConceptosRecargo: number | null,
    public readonly ConceptosRecargoNombre: string | null,
    public readonly MetodoRedondeoExpensa: number | null,
    public readonly MetodoRedondeoExpensaNombre: string | null,
    public readonly NotaExpensas: string | null,
    public readonly NotaExpensasPie: string | null,
    public readonly Activo: boolean,
    public readonly TenantId: number,
    public MediosPago: ConsorcioMedioPagoDto[],
    public Cuentas: Cuenta[]
  ) {}
}

export class SearchConsorcioRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly RazonSocial: string | null,
    public readonly NroDocumento: string | null,
    public readonly ProvinciaId: number | null,
    public readonly TenantId: number | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SaveConsorcioDto {
  constructor(
    public Id:number,
    public Nombre: string | null,
    public RazonSocial: string | null,
    public NroDocumento: string | null,
    public TipoDocumentoId: number,
    public ProvinciaId: number,
    public PaisId: number,
    public Direccion: string | null,
    public CodigoPostal: string | null,
    public Telefono: string | null,
    public Email: string | null,
    public TipoResponsableIvaId: number,
    public InteresVencimiento: number,
    public InteresMensual: number,
    public ConceptosRecargo: number,
    public MetodoRedondeoExpensa: number,
    public NotaExpensas: string | null,
    public NotaExpensasPie: string | null,
    public Activo: boolean,
    public MediosPago: ConsorcioMedioPagoDto[]
  ) {}
}

export class SearchConsorcioResponse {
  constructor(
    public readonly count: number,
    public readonly result: Consorcio[]
  ) {}
}

export class MetodoRedondeoExpensa {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string
  ) {}
}

export class ConceptosRecargo {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string
  ) {}
}

export class ConsorcioMedioPagoDto {
  constructor(
    public readonly Id: string | null,
    public readonly ConsorcioId: string | null,
    public MedioPagoId: number,
    public MedioPagoNombre: string | null,
    public readonly Titular: string | null,
    public readonly Cuit: string | null,
    public BancoId: number,
    public BancoNombre: string | null,
    public readonly CodigoUnico: string | null,
    public readonly Alias: string | null,
    public readonly NumeroCuenta: string
  ) {}
}